import { gql } from "@apollo/client";

export const BulkUploadValidationFragment = gql`
  fragment BulkUploadValidationFragment on BulkUploadValidationResult {
    items {
      id
      isUpdate
      isAddition
      hasError
      errorMessage
      unflattenedValue
      validationBreakdown
    }
    totalSent
    totalAdditions
    totalUpdates
    totalErrors
  }
`;

export const BulkUploadResultFragment = gql`
  fragment BulkUploadResultFragment on BulkUploadResult {
    errors {
      id
      unflattenedData
      errorMessage
    }
    totalSent
    totalAdditions
    totalUpdates
    totalErrors
  }
`;
